/**
 * Estado da lista de Novidades guardado durante a sessão, para a volta da leitura cair no mesmo filtro
 * e na mesma altura da página.
 */
export const estadoDaLista = {
	consulta: {} as Record<string, string>,
	rolagem: 0,
	/** Ligado quando se chega na lista vindo da leitura: aí a rolagem é restaurada. */
	voltando: false,
}

/** Item pedido na URL: `?item=3` ou `#item-3`. */
export function itemPedido(query: Record<string, unknown>, hash: string): number | null {
	const daConsulta = Number(query.item)
	if (Number.isInteger(daConsulta) && daConsulta > 0) return daConsulta
	const m = /^#item-(\d+)$/.exec(hash || '')
	return m ? Number(m[1]) : null
}

export const prefereMenosMovimento = () =>
	typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
